import { authHeader } from "../../../helpers/auth-header";
import { client } from "../../../actions";
import actions from "../store/actions/actions";
import { message } from "antd";
import { userActions } from "../../../actions/user.actions";

const getAllAddresses = () => async (dispatch) => {
	try {
		const { data } = await client.get(`/Meter/addresses`, {
			headers: authHeader(),
			params: { allAddress: true },
		});
		if (
			typeof data === "string" && data.includes("AuthenticationFailed")
		) {
			message.error("Произошла ошибка авторизации");
			dispatch(userActions.logout());
			return;
		}
		dispatch({
			type: actions.ALL_ADDRESSES_LOADED,
			payload: data,
		});
	} catch (e) {
		console.log(e);
		message.error("При загрузке адресов произошла ошибка");
	}
};

export default getAllAddresses;
